import React from 'react';
import {Alert} from 'react-bootstrap';

const AlertedBanner = () => (
    <Alert variant="warning" className="mb-4">
        <strong>Signalement transmis.</strong> Notre équipe a été notifiée.
        Le formulaire sera réactivé une fois le problème traité.
    </Alert>
);

export default AlertedBanner;
